import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Typography, Link, Grid } from '@material-ui/core';

import LanguageBar from 'components/common/LanguageBar';

import { Sidebar } from 'components/common/navigation';
import { SidebarContext } from 'providers/context';
import { ActionButton, IconButton } from 'components/common/buttons';
import { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';

const TopNavigation = ({ onNavigate }) => {
  const { formatMessage } = useIntl();
  const [toggleSidebar, setToggleSidebar] = useState(false);

  const termPrivacyLabel = (
    <>
      <Link href={formatMessage({ id: 'dashboard.sidebar.link.term' })} target="_blank" color="inherit" underline="none">
        {formatMessage({ id: 'dashboard.sidebar.footer.term' })}
      </Link>
    </>
  );

  const secLabel = (
    <>
      <Link href={formatMessage({ id: 'dashboard.sidebar.link.sec' })} target="_blank" color="inherit" underline="none">
        {formatMessage({ id: 'dashboard.sidebar.footer.sec' })}
      </Link>
    </>
  );

  const privLabel = (
    <>
      <Link href={formatMessage({ id: 'dashboard.sidebar.link.privacy' })} target="_blank" color="inherit" underline="none">
        {formatMessage({ id: 'dashboard.sidebar.footer.privacy' })}
      </Link>
    </>
  );

  const fees = (
    <Link href={formatMessage({ id: 'dashboard.sidebar.link.fees' })} target="_blank" color="inherit" underline="none">
      {formatMessage({ id: 'dashboard.sidebar.footer.fees' })}
    </Link>
  );

  return (
    <div className="flex flex-row justify-end header--links">
      <LanguageBar className="hidden-xs" />
      <div className="btn--right hidden-xs">
        <ActionButton
          isAssetIcon
          icon="registerAvatar"
          className="transparent-bw register"
          onClick={() => onNavigate('signup')}
          title={formatMessage({ id: 'buttonText.registerNow' })}
        />
      </div>

      <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
        <Sidebar className="no-bg">
          <div className="sidebar-home">
            <div className="visible-s">
              <Grid container>
                <Grid item xs={10}>
                  <LanguageBar />
                </Grid>
                <Grid item xs={12}>
                  <IconButton onClick={() => setToggleSidebar(false)}>
                    <CloseIcon style={{ fill: '#fff', top: -63, right: 8, position: 'absolute' }} />
                  </IconButton>
                </Grid>
              </Grid>
              <div className="ph3">
                <ActionButton
                  isAssetIcon
                  icon="registerAvatar"
                  className="transparent-bw"
                  onClick={() => onNavigate('signup')}
                  title={formatMessage({ id: 'buttonText.registerNow' })}
                />
              </div>
            </div>

            <div className="ph3 mv2">
              <div className="flex flex-row mv4">
                <Typography className="tc">{termPrivacyLabel}</Typography>
              </div>
              <div className="flex flex-row mv4">
                <Typography className="tc">{privLabel}</Typography>
              </div>
              <div className="flex flex-row mv4">
                <Typography className="tc">{secLabel}</Typography>
              </div>
              <div className="flex flex-row mv4">
                <Typography className="tc">{fees}</Typography>
              </div>
            </div>
          </div>
        </Sidebar>
      </SidebarContext.Provider>

      {/* <Sidebar className="no-bg visible-xs">
        <div className="sidebar-home">
          <div className="ph3">
            <ActionButton
              isAssetIcon
              icon="registerAvatar"
              className="transparent-bw"
              onClick={() => onNavigate('signup')}
              title={formatMessage({ id: 'buttonText.registerNow' })}
            />
          </div>

          <div className="flex flex-row mv6" style={{ position: 'absolute', bottom: -80 }}>
            <Typography className="tc">{termPrivacyLabel}</Typography>
          </div>

          <div className="flex flex-row mv6" style={{ position: 'absolute', bottom: -100 }}>
            <Typography className="tc">{secLabel}</Typography>
          </div>
        </div>
      </Sidebar> */}
    </div>
  );
};

TopNavigation.propTypes = { onNavigate: PropTypes.func.isRequired };

export default TopNavigation;
